export default "__VITE_ASSET__1b19726f__"